module.exports = __webpack_public_path__ + "fonts/Inter-500-greek53.8c7f6ae.woff2";